import { IAddressBookVerificationListItem } from "dto/Admin/IAddressBookVerification";
import { createContext } from "react";

type IAddressBookVerificationsContext = {
  verifications: IAddressBookVerificationListItem[];
  setVerifications: (verifications: IAddressBookVerificationListItem[]) => void;
};

const AddressBookVerificationsContext =
  createContext<IAddressBookVerificationsContext>({
    verifications: [],
    setVerifications: () => {},
  });

export default AddressBookVerificationsContext;
